import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    appBar: {
        // zIndex: theme.zIndex.drawer + 1,
        height: '100px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: 'white',
        boxShadow: 'none',

        [theme.breakpoints.down('md')]: {
            height: 'auto',
        },
    },
    appToolbar: {
        padding: '0px 70px',
        flex: 1,

        [theme.breakpoints.down('md')]: {
            padding: '13px 15px',
        },
    },
    logo: {
        width: '120px',

        [theme.breakpoints.down('md')]: {
            width: '80px',
        },
    },
    root: {
        display: 'flex',
        position: 'absolute',
    },
}));
